import { Component, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { HeadMenuDropmenuComponent } from '../head-menu-dropmenu/head-menu-dropmenu.component';

/**
 * Tap-friendly variant of head-menu-dropmenu for the small-screen dropdown.
 * Reuses the parent's menu item resolution (store children, Links and
 * ScheduleTypes tables) but renders as a nested mat-menu that a parent
 * mat-menu-item can trigger via [matMenuTriggerFor]="ref.menu".
 */
@Component({
  selector: 'head-menu-mobile-submenu',
  templateUrl: './head-menu-mobile-submenu.component.html',
  styleUrls: ['./head-menu-mobile-submenu.component.scss']
})
export class HeadMenuMobileSubmenuComponent extends HeadMenuDropmenuComponent {

  @ViewChild(MatMenu, { static: true }) menu!: MatMenu;

}
